/* Blissal TR — bundle picker, add to cart (Dawn cart drawer), delivery countdown, gallery thumbs, sticky ATC. */


async function blAddToCart(variantId, quantity = 1) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: Number(variantId), quantity }],
      sections: window.blCart?.sectionIds || ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    }),
  });
  const data = await response.json();
  if (!response.ok || data.status) {
    throw new Error(data.description || data.message || 'Sepete eklenemedi.');
  }
  return data;
}

function blRenderCart(data) {
  if (window.blCart) {
    window.blCart.render(data);
    window.blCart.open();
    return;
  }
  window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
}

class BlBundleForm extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-submit]');
    this.error = this.querySelector('.bl-bundle__error');
    this.button?.addEventListener('click', () => this.submit());
    this.addEventListener('change', (event) => {
      if (event.target.name?.startsWith('bl-color-')) this.applyColor(event.target.value);
      this.syncButton();
      this.dispatchEvent(new CustomEvent('bl:bundle-change', { bubbles: true, detail: this.selected() }));
    });
    const color = this.querySelector('input[name^="bl-color-"]:checked');
    if (color) this.applyColor(color.value);
    this.syncButton();
    this.startCountdown();
  }

  bundleInput() {
    return this.querySelector('input[name^="bl-bundle-"]:checked');
  }

  selected() {
    const input = this.bundleInput();
    return input ? { variantId: input.value, price: input.dataset.price, available: input.dataset.available !== 'false' } : null;
  }

  /* Points every bundle at the chosen color's variant; prices are shared, availability is not. */
  applyColor(color) {
    this.querySelectorAll('input[data-variants]').forEach((input) => {
      const variant = JSON.parse(input.dataset.variants)[color];
      if (!variant) return;
      input.value = variant.id;
      input.dataset.price = variant.price;
      input.dataset.available = String(variant.available);
      input.closest('label')?.classList.toggle('bl-bundle__option--soldout', !variant.available);
    });
    const name = this.querySelector('[data-color-name]');
    if (name) name.textContent = color;
  }

  syncButton() {
    if (!this.button) return;
    const selection = this.selected();
    const available = Boolean(selection?.available);
    this.button.disabled = !available;
    this.button.textContent = available ? this.button.dataset.label : this.button.dataset.soldout;
  }

  async submit() {
    const selection = this.selected();
    if (!selection || this.button.disabled) return;
    this.setLoading(true);
    this.error.hidden = true;
    try {
      const data = await blAddToCart(selection.variantId);
      blRenderCart(data);
    } catch (err) {
      this.error.textContent = err.message;
      this.error.hidden = false;
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.button.setAttribute('aria-busy', String(isLoading));
    if (isLoading) this.button.disabled = true;
    else this.syncButton();
  }

  /* Countdown to today's dispatch cut-off (Europe/Istanbul), plus a business-day delivery window. */
  startCountdown() {
    const eta = this.querySelector('[data-eta]');
    if (!eta) return;
    const cutoffHour = Number(this.dataset.cutoffHour || 14);
    const minDays = Number(this.dataset.minDays || 2);
    const maxDays = Number(this.dataset.maxDays || 4);
    const parts = { h: eta.querySelector('[data-h]'), m: eta.querySelector('[data-m]'), s: eta.querySelector('[data-s]') };
    const range = eta.querySelector('[data-eta-range]');
    const pad = (n) => String(n).padStart(2, '0');
    const formatter = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'short', timeZone: 'Europe/Istanbul' });

    const istanbulNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
    const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
    const addBusinessDays = (date, days) => {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (!isWeekend(d)) added++;
      }
      return d;
    };

    const tick = () => {
      const now = istanbulNow();
      let dispatch = new Date(now);
      dispatch.setHours(cutoffHour, 0, 0, 0);
      while (now >= dispatch || isWeekend(dispatch)) {
        dispatch.setDate(dispatch.getDate() + 1);
        dispatch.setHours(cutoffHour, 0, 0, 0);
      }
      const diff = Math.max(0, Math.floor((dispatch - now) / 1000));
      const hours = Math.min(99, Math.floor(diff / 3600));
      parts.h.textContent = pad(hours);
      parts.m.textContent = pad(Math.floor((diff % 3600) / 60));
      parts.s.textContent = pad(diff % 60);
      range.textContent = `${formatter.format(addBusinessDays(dispatch, minDays))} - ${formatter.format(addBusinessDays(dispatch, maxDays))}`;
    };

    tick();
    eta.hidden = false;
    this.timer = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}
customElements.define('bl-bundle-form', BlBundleForm);

/* Keeps thumbnail strip in sync with the main gallery carousel. */
document.querySelectorAll('.bl-pdp__media').forEach((media) => {
  const carousel = media.querySelector('bl-carousel');
  const thumbs = [...media.querySelectorAll('[data-thumb]')];
  if (!carousel || thumbs.length === 0) return;
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => carousel.scrollToIndex(Number(thumb.dataset.thumb))));
  carousel.addEventListener('bl:slide', (event) => {
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === event.detail.index)));
    const active = thumbs[event.detail.index];
    const strip = active?.parentElement;
    if (active && strip) {
      const target = active.offsetLeft - strip.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }
  });
});

/* Sticky add-to-cart bar, shown once the main buy button scrolls out of view. */
class BlStickyAtc extends HTMLElement {
  connectedCallback() {
    const section = document.getElementById(this.dataset.target);
    this.form = section?.querySelector('bl-bundle-form');
    const anchor = this.form?.querySelector('[data-submit]');
    if (!this.form || !anchor) return;
    this.hidden = false;
    this.price = this.querySelector('[data-sticky-price]');
    this.querySelector('[data-sticky-submit]').addEventListener('click', () => this.form.submit());
    const stickyButton = this.querySelector('[data-sticky-submit]');
    section.addEventListener('bl:bundle-change', (event) => {
      if (event.detail?.price) this.price.textContent = event.detail.price;
      stickyButton.disabled = event.detail?.available === false;
    });
    const initial = this.form.selected();
    if (initial?.price) this.price.textContent = initial.price;
    // Scroll-based check: an IntersectionObserver misses fast jumps from below the fold to above it.
    let ticking = false;
    const update = () => {
      ticking = false;
      this.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }
}
customElements.define('bl-sticky-atc', BlStickyAtc);
